// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"d6f2225e","431":"41418327"}[chunkId] + ".chunk.css";
};